import addDays from "date-fns/addDays";
import { graphql, readInlineData } from "react-relay";

import { usePaywallCheckerContext } from "scmp-app/components/article/article-paywall-checker/contexts";
import { useScmpWidgetConfig } from "scmp-app/lib/app/hooks";
import type { useShareContentUnlockedArticle$key } from "scmp-app/queries/__generated__/useShareContentUnlockedArticle.graphql";

export const useShareContentUnlocked = (article_: useShareContentUnlockedArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment useShareContentUnlockedArticle on Article @inline {
        entityId
      }
    `,
    article_,
  );
  const { scmpWidgetConfigState } = useScmpWidgetConfig();
  const { shareContentUnlocked } = usePaywallCheckerContext();

  if (shareContentUnlocked) {
    const shareArticleExpiresDay =
      Number.parseInt(scmpWidgetConfigState.result?.share_article_expires_day ?? "") ?? 0;

    return (
      shareContentUnlocked?.entityId === article.entityId &&
      addDays(new Date(shareContentUnlocked?.shareTime), shareArticleExpiresDay) > new Date()
    );
  }

  return false;
};
